import {observable, computed, action} from 'mobx';
import uuidv4 from 'uuid/v4';

export default class PolicyAuth {
	

	@observable id = uuidv4();
	
	@observable policyNumber = null;

	@observable policyExpiryDate = null;

	@observable policyUniqueCode = null;

	@observable policyPostCode = null;

	/**
	 * Set the policy number
	 * @param {string} value - The policy number
	 */
	@action setPolicyNumber(value) {
		this.policyNumber = value || null;
	}

	/**
	 * Set the policy expiry date
	 * @param {?string} value - The policy expiry date
	 */
	@action setPolicyExpiryDate(value) {
		this.policyExpiryDate = value || null;
	}

	/**
	 * Set the policy unique code
	 * @param {?string} value - The policy unique code
	 */
	@action setPolicyUniqueCode(value) {
		this.policyUniqueCode = value || null;
	}

	/**
	 * Set the policy post code
	 * @param {?string} value - The policy post code
	 */
	@action setPolicyPostCode(value) {
		this.policyPostCode = value || null;
	}

	@computed
	get toServiceLayerPrelimInfo() {
		return {
			type: 'PolicySearch',
			id: this.id,
			attributes: {
				criteria: {
					policyNumber: this.policyNumber || null,
					policyExpiryDate: this.policyExpiryDate || null,
					policyPostcode: this.policyPostCode || null,
				},
			},
		};
	}
}

export class PrelimInfoFactory {
	/**
	 * Create an Wage from a plain old object
	 * @param prelimInfo
	 * @returns {?Wage}
	 */
	static createFromFormObject(prelimInfo) {
		if (!prelimInfo) {
			return null;
		}
		const policyAuth = new PolicyAuth();
	 
		policyAuth.setPolicyNumber(prelimInfo.policyNumber);
		policyAuth.setPolicyExpiryDate(prelimInfo.policyExpiryDate);
		policyAuth.setPolicyUniqueCode(prelimInfo.policyUniqueCode);
		policyAuth.setPolicyPostCode(prelimInfo.policyPostCode);
		return policyAuth;
	}
}
